/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'

import { Box, Button, Spinner } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useMeetingData from 'modules/upsell/hooks/useMeetingData'

export interface IntroFooterProps {
  onRequestContact: () => void
  isLoading?: boolean
  setIsCalendarAvailable: (arg: boolean) => void
}

const IntroFooter = ({ isLoading, onRequestContact, setIsCalendarAvailable }: IntroFooterProps) => {
  const [showCalendarButton, setShowCalendarButton] = React.useState(false)
  const [loader, setLoader] = React.useState(true)
  const { shouldShowCalendar } = useMeetingData({
    onSuccessEvent: trackingEvents.upsell.upsellMeetingBooked,
  })

  useEffect(() => {
    shouldShowCalendar().then((shouldShow) => {
      setShowCalendarButton(shouldShow)
      setLoader(false)
    })
  }, [])

  const onClick = () => {
    track(trackingEvents.upsell.openUpsellBookingCalendar)
    setIsCalendarAvailable(true)
  }

  if (loader) return <Spinner size="s32" />

  return (
    <Box flexDirection="row" width="full" justifyContent="flexEnd" gap="s8">
      <Button
        onClick={onRequestContact}
        disabled={isLoading}
        type={showCalendarButton ? 'secondary' : 'upgrade'}
      >
        {showCalendarButton ? i18n.t('upsell.contact_me') : i18n.t('upsell.request_modal.cta')}
      </Button>
      {showCalendarButton && (
        <Button onClick={onClick} disabled={isLoading} type="upgrade">
          {i18n.t('upsell.book_a_meeting')}
        </Button>
      )}
    </Box>
  )
}

export default IntroFooter
